import React from "react";

const notes = {

    title: "My Notes",
    addNewNoteButtonText: 'Add New Task',
    overdueNotesLabel: 'Overdue',
    completeNotesLabel: 'Completed',
    totalNotesLabel: 'Total Notes',
    searchBarPlaceholder: 'Search tasks...',
    allNotesBtnText: 'All Notes',
    highPriorityNotesBtnText: 'High Priority',
    scheduledNotesBtnText: 'Scheduled',
    completedNotesBtnText: 'Completed',
    addNoteModal: {
        okButtonLabel: 'Save Note',
        title: 'Add New Note',
        editTitle: 'Edit Note',
        inputTitleLabel: 'Note Title',
        titleInputPlaceholder: 'Enter title here , ex: Checklist....',
        inputContentLabel: 'Note Content',
        priorityTitleLabel: 'Priority',
        deadlineTitleLabel: 'Deadline / Due Date',
        colorInputLabel: 'Note Color',
        tagInputLabel: 'Tags',
        tagInputPlaceholder: 'Add tags(press Enter)...'
    },
    emptyTitle: 'No notes yet',
    emptyContent: ' Your notepad is empty. Start capturing ideas, reminders, and important tasks — all in one place.'
}

export default notes;
